<button appRipple *ngIf="canShare && canDisplay" data-test="share-button"
        class="share accent-background accent-contrast-color accent-contrast-border flex gap-[10px] justify-center items-center"
        (debounceClick)="share()">
    <cds-svg-icon name="share"></cds-svg-icon>
    <p>{{ 'send.share.share' | translate }}</p>
</button>
